import moment from "moment-timezone";
import { useEffect, useState } from "react";

const LIVE_TICK_MS = 30 * 1000;

/**
 * Current time in event timezone, overridable so organizers can rehearse
 * check-in against a different time of day.
 */
export const useMockableNow = () => {
  const [mockNow, setMockNow] = useState<moment.Moment | null>(null);
  const [liveNow, setLiveNow] = useState(() => moment().tz("America/New_York"));

  useEffect(() => {
    if (mockNow) return;

    const interval = setInterval(
      () => setLiveNow(moment().tz("America/New_York")),
      LIVE_TICK_MS
    );
    return () => clearInterval(interval);
  }, [mockNow]);

  // An invalid moment would make every comparison silently return false.
  const now = mockNow && mockNow.isValid() ? mockNow : liveNow;

  return { now, mockNow, setMockNow };
};
